<template>
  <div class="mainCon">
    <div class="title_border">
      <stu-main-title></stu-main-title>
      <div>
        <span style="color: #9299A6;">考生：</span>
        <span style="margin-right: 16px;">{{ userInfo.realName }}</span>
        <span style="color: #9299A6;">证件号：</span>
        <span>{{ userInfo.userName }}</span>
        <el-link type="primary" @click="exportScoreListPdf" style="margin:0px 0px 2px 10px" :underline="false">下载成绩单</el-link>
      </div>
    </div>
    <div class="content">
      <ots-table-new
        v-if="!showNull"
        :tableHeader="tableHeader"
        :tableData="tableData"
      ></ots-table-new>
      <div v-else class="noScore">
        <img src="@/assets/stuImg/nothing.png" alt="" />
        <span class="col_grayQ">成绩暂未发布，请等待</span>
      </div>
    </div>

    <ots-custom-dialog :dialog.sync="showSubCourseScoreFlag" title="查看单科分数线" width="50%">
      <template v-slot:content>
        <div class="SubCourseDialog">
          <div class="SubCourseDialogHeader">
            <div><b>考试科目</b></div>
            <div><b>分数</b></div>
          </div>
          <div v-for="(item, index) in subScoreList" :key="index" class="SubCourseDialogItem">
            <div>{{ Object.keys(item)[0] }}</div>
            <div>{{ Object.values(item)[0] }}</div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="showSubCourseScoreFlag = false">关闭</el-button>
      </template>
    </ots-custom-dialog>
  </div>
</template>
<script>
import { getCurrentPlanFn } from "@/http/modules/examSet/examBatch";
import { selectUserInfo } from "@/http/modules/student/ticket";
import {
  getScoreList,
  exportScoreList,
  exportCertificate,
  getStudentScoreReviewSubCourseInfoAPI,
  getStudentScoreReviewSubCourseDetailAPI
} from "@/http/modules/student/score";
export default {
  name: "stuScore",
  data() {
    return {
      // Reviewitem: "",
      // scoreReviewEndTime: "",
      // scoreReviews: "",
      showNull: false,
      tableHeader: [
        {
          title: "考试批次",
          prop: "planName",
        },
        {
          title: "考试科目",
          prop: "course",
        },
        {
          title: "成绩",
          prop: "result",
        },
      ],
      tableData: [],
      tableHeaderInfo: [
        {
          title: "考试科目",
          prop: "subCourseName",
        },
        {
          title: "科目满分成绩",
          prop: "score",
        },
        {
          title: "科目成绩得分",
          prop: "answerScore",
          align: "center"
        },
        // {
        //   title: "操作",
        //   type: "buttons",
        //   btnList: [
        //   {
        //     title: "详情",
        //     click: this.showScoreInfoDetail,
        //   },
        // ],
        // }
      ],
      tableDataInfo: [],
      userInfo: {},
      oPlanInfo:"",
      // 配置是否开启
      oNeedCertificatePrintInfo:"",
      showSubCourseScoreFlag: false,
      subScoreList: [],
    };
  },
  async created() {
    this.PlanFnId();
    await this.getScoreData();
    this.ConfigDataitemts;
    /* ** 是否可以下载合格证 ** */
    this.isDownLoadScore();
  },
  mounted() {
    let userInfo = window.localStorage.getItem("userInfo")
    this.userInfo = JSON.parse(userInfo);
  },
  methods: {
    // // 查看子科目成绩
    // showScoreInfo(row) {
    //   console.log(row);
    // },

    // // 查看子科目详情
    // showScoreInfoDetail(row) {
    //   let params = {
    //     subCourseCode: row.subCourseCode,
    //     studentCourseId: "",
    //   }
    //   console.log(val)
    // },

    /*******************************************
     * @isDownLoadScore 判断 - 是否可以下载合格证
     *******************************************/
    isDownLoadScore() {
      const outputScoreFlag = this.tableData.some(item => item.outputScore == 1)
      if(outputScoreFlag && !this.showNull && this.tableData){
        //如果有outputScore==1的数据并且列表中有值，则添加“分数”列
        this.tableHeader.push({
          title: "分数",
          prop: "score",
          align:'center',
          headerAlign: "center",
        });
      }

      this.$api.system.getConfigData().then(({ data }) => {
        let buttons = {
          title: "操作",
          type: "buttons",
          width: "260",
          btnList: []
        };
        buttons.btnList.push({
          title: (val) => {
            return  val.row.haveSubCourse == 1 
                    && val.row.subScoreList 
                    && val.row.subScoreList.length > 0 
                    && val.row.outputScoreSub == 1
            ? "查看单科分数" : "";
          },
          click: this.showSubCourseScore,
        })

        data.configList.map((e) => {
          if (e.setName == "showExamCheckState") {
            if (e.setValue == 1) {
              this.tableHeader.push({
                title: "考试状态",
                prop: "checkStateName",
                align:'center',
                headerAlign: "center",
              });
            } else {
            }
          }
          if (e.setName == "needCertificatePrint") {
            this.oNeedCertificatePrintInfo = e;
            buttons.btnList.push({
              title: (val) => {
                // 下载合格证按钮 有3个条件 开关室 setvalue:1,成绩发布：scorepublish:1 成绩是否通过 （1 通过）
                if (e.setValue == 1 && val.row.isPass == 1 && this.oPlanInfo.scorePublish == 1 ) {
                  return "下载合格证";
                } else {
                  if(this.oPlanInfo.scorePublish == 1 && this.oPlanInfo.scoreReview == 1 ){
                    if(val.row.reviewed == 1){
                      return "";
                    }else{
                      if(val.row.isPass == 0 && this.scoreReviewEndTime > this.Reviewitem){
                        return "";
                      }else{
                        return "--";
                      }
                    }
                  }else{
                    return "--";
                  }
                }
              },
              click: this.downCertificate,
            });
            buttons.btnList.push({
              title: (val) => {
                //scorePublish 成绩是否发布
                // scoreReview  成绩复核的开关
                // scoreReviewEndTime 成绩复核的截止日期
                // reviewed  1-有申诉记录，0-无申诉记录
                if(this.oPlanInfo.scorePublish == 1 && this.oPlanInfo.scoreReview == 1 ){
                  if(val.row.reviewed == 1){
                    return "查看复核";
                  }else{
                    if(val.row.isPass == 0 && this.scoreReviewEndTime > this.Reviewitem && this.Reviewitem > this.scoreReviewBeginTime){
                      return "复核";
                    }
                  }
                }
              },
              click: this.downRepresentations,
            });
          }
        });
        this.tableHeader.push(buttons);
      });
    },
    async getScoreData() {
      const { data: plan } = await getCurrentPlanFn({
        planId: this.getCurrentGlobalPlanId(),
      });
      const { data: user } = await selectUserInfo();
      this.user = user;
      let param = {
        planId: "d403db7d-c9e5-4325-928c-b2b7f3df5acd",
        userId: user.id,
      };
      const { data } = await getScoreList({
        planId: this.getCurrentGlobalPlanId(),
      });
      if (data) {
        this.tableData = data;
      } else {
        this.showNull = true;
      }
    },
    async downScore(val) {
      const { courseId, planId } = val;
      const { data } = await exportScoreList({ courseId, planId });
      if (data) {
        window.location.href = data;
      }
    },
    async ConfigDataitemts() {
      let { data } = await ConfigData();
      data.configList.map((e) => {
        if (e.setValue == 1) {
          this.setValuePrint = 1;
        }
      });
    },
    async PlanFnId() {
      let { data } = await getCurrentPlanFn({
        planId: this.getCurrentGlobalPlanId(),
      });
      this.oPlanInfo = data;
      this.scoreReviews = data.scoreReview;
      this.scoreReviewBeginTime = new Date(data.scoreReviewBeginTime).getTime();
      this.scoreReviewEndTime = new Date(data.scoreReviewEndTime).getTime();
      this.Reviewitem = new Date().getTime();
    },
    downRepresentations(row) {
      this.$router.push({
        path: "/stuHome/representations",
        query: {
          id: row.planId,
          studentCourseId: row.studentCourseId,
        },
      });
    },
    showSubCourseScore(row) {
      this.showSubCourseScoreFlag = true;
      this.subScoreList = row.subScoreList;
    },
    async downCertificate(row) {
      if(this.oNeedCertificatePrintInfo.setValue == 1 && row.isPass == 1 && this.oPlanInfo.scorePublish == 1){
        const { data } = await exportCertificate({
          cardNo: this.user.cardNo,
          planId: row.planId,
          courseId: row.courseId,
        });
        if (data) {
          window.open(data);
        }
      }
    },
    async exportScoreListPdf() {
      const { data, code } = await this.$api.system.getScoreListPdfFn({planId : this.getCurrentGlobalPlanId()});
      if (code) {
        window.open(data);
      }
    }
  },
};
</script>
<style lang="less" scoped>
.mainCon {
  box-sizing: border-box;
  padding: 20px;
  padding-top: 16px;
  width: 100%;
  min-width: 700pt;
  background: rgba(255, 255, 255, 0.93);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.5);
  .title_border {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .content {
    padding-top: 20px;
    .noScore {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 40px;
      padding-bottom: 80px;
    }
  }
}
/deep/ .el-table th,
.el-table tr {
  background-color: #ebecff !important;
}
.SubCourseDialog{
  .SubCourseDialogHeader, .SubCourseDialogItem{
    display: flex;
    line-height: 35px;
    padding: 0px 10%;
  }
  .SubCourseDialogHeader div, .SubCourseDialogItem div{
    width:50%;
    text-align: center;
  }
}
</style>
